function fn_part_slider() {
    var $fn = $(".part_slider");

    if($fn.length) {
        var $slider_bg = $fn.find(".slider_bg"),
            $slider_front = $fn.find(".slider_front"),
            $front_arrows = $slider_front.data("arrows"),
            $slider_controls = $slider_front.next(".elm_slider_controls"),
            $front_arrow_prev = $slider_controls.find(".slick-prev"),
            $front_arrow_next = $slider_controls.find(".slick-next"),
            $slider_list = $slider_controls.find(".elm_model_select"),
            $slider_goto = $slider_front.data("goto"),
            $notenough = false;

        if($slider_front.find(".elm_slide").length == 1){
            $slider_front.addClass("mod--notenough");
            $slider_front.find(".elm_slide").addClass("slick-center");
            $front_arrow_next.hide();
            $front_arrow_prev.hide();
            return;
        }

        $slider_bg.slick({
            slidesToShow: 1,
            fade: true,
            asNavFor: $slider_front,
            arrows: false
        });

        $slider_front.on('init reInit', function(event, slider){
            if(slider.slideCount <= slider.options.slidesToShow){
                console.log("true");
                $notenough = true;
            }
        });

        $slider_front.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: true,
            fade: false,
            asNavFor: $slider_bg,
            dots: false,
            arrows: $front_arrows,
            prevArrow: $front_arrow_prev,
            nextArrow: $front_arrow_next,
            responsive: [
                {
                    breakpoint: "960",
                    settings: {
                        slidesToShow: 1
                        // arrows: false
                    }
                }
            ]
        });

        $slider_front.on('afterChange', function(slick, currentSlide){
            $(this).find(".slick-active").find("img").addClass("lazyload");
            $slider_list.find(".mod--active").removeClass("mod--active");
            $slider_list.find("li").eq(currentSlide.currentSlide).addClass("mod--active");
        });

        $slider_list.on("click","li",function (e) {
            e.preventDefault();
            $slider_list.find(".mod--active").removeClass("mod--active");
            var $this = $(this);
            $this.addClass("mod--active");
            $slider_front.slick("slickGoTo",$this.index(),false);
        });

        if($slider_goto) {
            var $index = $slider_front.find(".slick-slide:not(.slick-cloned)").filter("[data-product-id="+$slider_goto+"]").data("slick-index");
            console.log($index);
            $slider_front.slick("slickGoTo",$index);
        }

        function notEnough() {
            if($notenough && $(window).width() > 980){
                $slider_front.addClass("mod--notenough");
                $slider_front.slick("slickSetOption","slidesToShow",1,true);
            }
        }

        notEnough();

        $(window).on('resize', function(){
            notEnough();
        });
    }
}